import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import {
  Checkbox,
  FormControl,
  Grid,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from '@mui/material';
import React from 'react';

const types = [
  { id: 'testcases', name: 'Test Cases' },
  { id: 'testcycles', name: 'Test Cycles' },
];

const ExportDataSelectionForm = ({
  projects = [],
  exportOptions,
  setExportOptions,
}) => {
  const handleProjectSelection = (event, type) => {
    const {
      target: { value },
    } = event;
    setExportOptions((prev) => ({
      ...prev,
      [type]: typeof value === 'string' ? value.split(',') : value,
    }));
  };

  return (
    <>
      <Grid container spacing={2}>
        {projects?.length > 0 && (
          <Grid item xs={12}>
            <Typography variant="subtitle1">Select Projects</Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
              Choose the projects you want to include in the export. All test
              cases and related data within the selected projects will be
              exported.
            </Typography>
            <FormControl fullWidth>
              <Select
                id="project-selection"
                multiple
                value={exportOptions.projects}
                onChange={(e) => handleProjectSelection(e, 'projects')}
                input={<OutlinedInput placeholder="Select Projects" />}
                renderValue={(selected) =>
                  selected.length === 0
                    ? 'No projects selected'
                    : selected
                        .map(
                          (id) =>
                            projects.find((project) => project.id === id)?.name
                        )
                        .join(', ')
                }
                IconComponent={KeyboardArrowDownIcon}
                sx={{ maxHeight: '48px' }}>
                {projects.map((project) => (
                  <MenuItem key={project.id} value={project.id}>
                    <Checkbox
                      checked={exportOptions?.projects?.includes(project.id)}
                    />
                    <ListItemText primary={project.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        )}

        {/* <Grid item xs={12}>
          <Typography variant="subtitle1">Select Data to Export</Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
            Choose the type of data you want to include in the export for the
            selected projects.
          </Typography>
          <FormControl fullWidth>
            <Select
              id="entities-selection"
              multiple
              value={exportOptions?.options}
              onChange={(e) => handleProjectSelection(e, 'options')}
              input={<OutlinedInput placeholder="Select data" />}
              renderValue={(selected) =>
                selected.length === 0
                  ? 'No options selected'
                  : selected
                      .map(
                        (id) => types?.find((option) => option.id === id)?.name
                      )
                      .join(', ')
              }
              IconComponent={KeyboardArrowDownIcon}
              sx={{ maxHeight: '48px' }}>
              {types?.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  <Checkbox
                    checked={exportOptions?.options?.includes(option.id)}
                  />
                  <ListItemText primary={option.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid> */}
      </Grid>
    </>
  );
};

export default ExportDataSelectionForm;
